// 说明
// 该mixin为实现阻止页面刷新和关闭
// 尝试了三种办法，如下
//
// 一、addEventListener
// 在谷歌浏览器无作用
//
// 二、onbeforeunload
// 有效
//
// 三、index.html中script
//<script type="text/javascript">
//  window.addEventListener("beforeunload", listenClose, false);
//
//  // function unListen() {
//  //   window.removeEventListener('beforeunload', listenClose, false);
//  // }
//
//  function listenClose(e) {
//    var confirmationMessage = '业务未执行完成，离开本页面会导致执行失败，是否现在离开？';
//    (e || window.event).returnValue = confirmationMessage;
//    return confirmationMessage;
//  }
//</script>
// 有效
// 
// 如何使用（一、二）
// 
// /App.vue
// import mixin_preventUnload from '@/mixins/mixin_preventUnload'
// mixins: [mixin_preventUnload],
// 
export default {
  // methods: {
  //   // 页面关闭刷新回调
  //   beforeunloadHandler(e) {
  //     var confirmationMessage = 'close'
  //     (e || window.event).returnValue = confirmationMessage
  //     return confirmationMessage
  //   },
  // },
  mounted() {
    // console.log(100)
    // window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
    
    if (this.isPro) {
      window.onbeforeunload = e => {
        (e || window.event).returnValue = this.$t('common.closeWarning')
        return this.$t('common.closeWarning')
      }
    }
  },
  // beforeDestroy() {
  //   console.log(200)
  //   window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
  // },
}